export default [
  {
    title: 'English',
    locale: 'en',
  },
  {
    title: 'German',
    locale: 'de',
  },
  {
    title: 'French',
    locale: 'fr',
  },
  {
    title: '日本語',
    locale: 'ja',
    alternate: 'ja-JP',
  },
  {
    title: '简体中文',
    locale: 'zh-CN',
    alternate: 'zh-Hans',
  },
  {
    title: 'Help translate',
    locale: 'eo-UY',
  },
];
